import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {Monitor} from '../../models/eventRequest';
import {MonitorService} from '../../_services/monitor.service';
import {Router} from '@angular/router';
import {ReadOnlyService} from '../../_services/read-only.service';

@Component({
    selector: 'app-monitor-list',
    templateUrl: './monitor-list.component.html',
    styleUrls: ['./monitor-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MonitorListComponent implements OnInit {

  monitors?: Monitor[];
  searchTerm = '';
  statusFilter: 'ACTIVE' | 'DISABLED' | 'ALL' = 'ACTIVE';
  togglingId?: number;
  errorMessage = '';

  constructor(private monitorService: MonitorService, private router: Router, public readOnlyService: ReadOnlyService) {
    this.monitorService.loadAbsentMonitorId();
    this.monitorService.getAllMonitors(true).subscribe((monitors: Monitor[]) => {
      this.monitors = monitors;
    })
  }

  ngOnInit(): void {
  }

  consultMonitor(id: any) {
    this.router.navigate(['monitors/' + id]);
  }

  /** Filtre sur le statut, puis sur le nom, le prénom, le téléphone ou l'email. */
  filteredMonitors(): Monitor[] {
    const term = this.searchTerm.trim().toLowerCase();
    return (this.monitors || [])
      .filter(m => this.statusFilter === 'ALL' || (this.statusFilter === 'DISABLED') === this.isDisabled(m))
      .filter(m => !term
        || [m.lastname, m.firstname, m.phoneNumber, m.email].some(v => (v || '').toLowerCase().includes(term)));
  }

  countByStatus(status: 'ACTIVE' | 'DISABLED' | 'ALL'): number {
    return (this.monitors || []).filter(m => status === 'ALL' || (status === 'DISABLED') === this.isDisabled(m)).length;
  }

  isDisabled(m: Monitor): boolean {
    return m.enabled === false;
  }

  initials(m: Monitor): string {
    return ((m.firstname || '').charAt(0) + (m.lastname || '').charAt(0)).toUpperCase() || '?';
  }

  canToggle(m: Monitor): boolean {
    return !this.readOnlyService.isReadOnly() && !this.isAbsentMonitor(m);
  }

  /** Active / désactive le moniteur (et son compte). */
  toggleEnabled(m: Monitor, event: Event) {
    event.stopPropagation();
    const enable = this.isDisabled(m);
    this.errorMessage = '';
    this.togglingId = m.id;
    this.monitorService.setEnabled(m.id, enable).subscribe(
      (updated: Monitor) => {
        m.enabled = updated.enabled;
        this.togglingId = undefined;
      },
      err => {
        const detail = err?.error?.message || (err?.status ? 'erreur ' + err.status : 'serveur injoignable');
        this.errorMessage = `Impossible de modifier le statut de ${m.firstname} ${m.lastname} (${detail}).`;
        this.togglingId = undefined;
      });
  }

  isAbsentMonitor(m: Monitor): boolean {
    return this.monitorService.isAbsentMonitor(m.id);
  }
}
